import { render, staticRenderFns } from "./PageOrderConfirmed.vue?vue&type=template&id=32325e1a&scoped=true&"
import script from "./PageOrderConfirmed.vue?vue&type=script&lang=js&"
export * from "./PageOrderConfirmed.vue?vue&type=script&lang=js&"
import style0 from "./PageOrderConfirmed.vue?vue&type=style&index=0&id=32325e1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32325e1a",
  null
  
)

export default component.exports